import { fromOthersNodeName } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { BookOfMind } from "source/app/presentation/MainPanel/Workflows/BookOfMind/BookOfMind";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";

export function ShowAllQuotes({ rootNodeName }: { rootNodeName: string; }) {
    return (
        <IconWithText
            id="ToggleFocusedDisplay"
            iconSuffix={EGlyphicon.book}
            whenClicked={() => BookOfMind(fromOthersNodeName)}
            displayAsBlock={false}
        >
            Show All
        </IconWithText>
    );
}
